import { environment } from '../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxCurrencyModule } from "ngx-currency";
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { SubstrPipe } from './service/pipe/substr.pipe';




import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';

import { DropzoneModule, DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ProfileService } from './service/profile/profile.service';
import { SaleHomeComponent } from './sale/sale-home/sale-home.component';
import { SaleLsfPagesComponent } from './sale/sale-factor/sale-lsf/sale-lsf-pages/sale-lsf-pages.component';
import { SiteHomeComponent } from './site/site-home/site-home.component';
import { ServerService } from './service/server/server.service';
import { MessageService } from './service/message/message.service'
import * as $ from 'jquery';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: 'https://server1.hooshmandsazeh.com/upload',
  maxFilesize: 5,
  dictDefaultMessage: "",
  init: function () {

  }//end init
};
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { UserListComponent } from './system/user/user-list/user-list.component';
import { SaleAttachmentComponent } from './sale/sale-attachment/sale-attachment.component';
import { SaleProcessComponent } from './sale/sale-process/sale-process.component';
import { SaleShopComponent } from './sale/sale-shop/sale-shop.component';
import { SaleShopProcessComponent } from './sale/sale-shop-process/sale-shop-process.component';
import { SaleDocumentDeclarationComponent } from './sale/sale-document/sale-document-declaration/sale-document-declaration.component';
import { SaleDocumentDesign1Component } from './sale/sale-document/sale-document-design1/sale-document-design1.component';
import { SaleDocumentDesign2Component } from './sale/sale-document/sale-document-design2/sale-document-design2.component';
import { SaleDocumentFoundComponent } from './sale/sale-document/sale-document-found/sale-document-found.component';
import { SaleDocumentProductComponent } from './sale/sale-document/sale-document-product/sale-document-product.component';
import { SaleDocumentSendComponent } from './sale/sale-document/sale-document-send/sale-document-send.component';
import { WeightComponent } from './sale/setting/weight/weight.component';
import { TickComponent } from './sale/setting/tick/tick.component';
import { AreaComponent } from './sale/setting/area/area.component';
import { FloorWeightComponent } from './sale/setting/floor-weight/floor-weight.component';
import { InstallPlaceComponent } from './sale/setting/install-place/install-place.component';
import { CraterComponent } from './sale/setting/crater/crater.component';
import { DesignComponent } from './sale/setting/design/design.component';
import { TipComponent } from './sale/setting/tip/tip.component';
import { InstallCeilComponent } from './sale/setting/install-ceil/install-ceil.component';
import { InstallStructureComponent } from './sale/setting/install-structure/install-structure.component';
import { InstallRunPositionComponent } from './sale/setting/install-run-position/install-run-position.component';
import { InstallSiteComponent } from './sale/setting/install-site/install-site.component';
import { InstallOpenCraterComponent } from './sale/setting/install-open-crater/install-open-crater.component';
import { InstallHeightComponent } from './sale/setting/install-height/install-height.component';
import { ServerBackendListComponent } from './service/server-backend/server-backend-list/server-backend-list.component';
import { ServerBackendCodesComponent } from './service/server-backend/server-backend-codes/server-backend-codes.component';
import { ShopFloorComponent } from './sale/setting/shop-floor/shop-floor.component';
import { SaleProcessDetaileComponent } from './sale/sale-process-detaile/sale-process-detaile.component';
import { UserDetaileComponent } from './system/user/user-detaile/user-detaile.component';
import { UserCateComponent } from './system/user/user-cate/user-cate.component';
import { UserJobComponent } from './system/user/user-job/user-job.component';
import { appRoutingModule } from './app.routing.module';
import { ShopServiceComponent } from './shop-service/shop-service.component';
import { SaleFactorDetaileComponent } from './sale/sale-factor-detaile/sale-factor-detaile.component';
import { CrmTaskComponent } from './site/crm/crm-task/crm-task.component';
import { CrmTaskDetaileComponent } from './site/crm/crm-task-detaile/crm-task-detaile.component';
import { SiteCrmCoopComponent } from './site/site-crm/site-crm-coop/site-crm-coop.component';
import { SiteCrmProjectComponent } from './site/site-crm/site-crm-project/site-crm-project.component';
import { SiteCrmVisitComponent } from './site/site-crm/site-crm-visit/site-crm-visit.component';
import { UserUvalueComponent } from './system/user/user-uvalue/user-uvalue.component';
import { UserDetaile2Component } from './system/user/user-detaile2/user-detaile2.component';
import { SearchSupplierService } from './service/supplier/search/search-supplier.service';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { SalePrintComponent } from './sale/sale-print/sale-print.component';
import { SaleSearchComponent } from './sale/sale-search/sale-search.component';
import { ModulesComponent } from './service/modules/modules.component';
import { UserInsertComponent } from './system/user/user-insert/user-insert.component';
import { SaleCommentComponent } from './sale/sale-comment/sale-comment.component';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { SalePaymentListComponent } from './sale/sale-payments/sale-payment-list/sale-payment-list.component';
import { SalePaymentDetaileComponent } from './sale/sale-payments/sale-payment-detaile/sale-payment-detaile.component';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';

import { MatNativeDateModule } from '@angular/material/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatCoreModule } from "./service/mat-core/mat-core.module";
import { SalePaymentsList2Component } from './sale/sale-payments/sale-payments-list2/sale-payments-list2.component';
import { HighchartsChartModule } from 'highcharts-angular';

import { PaccessComponent } from './system/service/menu/paccess/paccess.component';
import { GaccessComponent } from './system/service/menu/gaccess/gaccess.component';
import { MenuItemsComponent } from './system/service/menu/menu-items/menu-items.component';
import { TabComponent } from './system/service/menu/tab/tab.component';
import { UserGroupsComponent } from './system/user/user-groups/user-groups.component';

import { ChequeDetaileComponent } from './system/finance/cheque/cheque-detaile/cheque-detaile.component';
import { Financial2DetaileComponent } from './system/finance/financial2/financial2-detaile/financial2-detaile.component';
import { BankAccountsComponent } from './system/finance/bank/bank-accounts/accounts-list/bank-accounts.component';
import { AccountsDetaileComponent } from './system/finance/bank/bank-accounts/accounts-detaile/accounts-detaile.component';
import { BankChequeNumbersComponent } from './system/finance/bank/bank-cheque-numbers/bank-cheque-numbers.component';
import { ChequeSelectComponent } from './system/finance/cheque/cheque-select/cheque-select.component';

import { MaterialListComponent } from './system/wharehouse/wharehouse-material/material-list/material-list.component';
import { MaterialDetaileComponent } from './system/wharehouse/wharehouse-material/material-detaile/material-detaile.component';
import { WharehouseOrderStatusComponent } from './system/wharehouse/wharehouse-order-status/wharehouse-order-status.component';
import { OrderListComponent } from './system/wharehouse/wharehouse-order/order-list/order-list.component';
import { OrderDetaileComponent } from './system/wharehouse/wharehouse-order/order-detaile/order-detaile.component';
import { WharehouseMaterialCateComponent } from './system/wharehouse/wharehouse-material-cate/wharehouse-material-cate.component';
import { WharehouseMaterialCateDetaileComponent } from './system/wharehouse/wharehouse-material-cate-detaile/wharehouse-material-cate-detaile.component';
import { WharehouseMaterial2Component } from './system/wharehouse/wharehouse-material/wharehouse-material2/wharehouse-material2.component';
import { WharehouseCostCenterComponent } from './system/wharehouse/wharehouse-cost-center/wharehouse-cost-center.component';
import { ExitListComponent } from './system/wharehouse/wharehouse-exit/exit-list/exit-list.component';
import { ExitDetaileComponent } from './system/wharehouse/wharehouse-exit/exit-detaile/exit-detaile.component';
import { InvoiceListComponent } from './system/wharehouse/wharehouse-invoice/invoice-list/invoice-list.component';
import { InvoiceDetaileComponent } from './system/wharehouse/wharehouse-invoice/invoice-detaile/invoice-detaile.component';
import { WharehouseInvoiceTypeComponent } from './system/wharehouse/wharehouse-invoice-type/wharehouse-invoice-type.component';
import { SearchMaterialComponent } from './system/wharehouse/search-material/search-material.component';
import { NewFastMaterialComponent } from './system/wharehouse/new-fast-material/new-fast-material.component';
import { Wreport1Component } from './system/wharehouse/wharehouse-report/wreport1/wreport1.component';
import { NewFastMaterial2Component } from './system/wharehouse/new-fast-material2/new-fast-material2.component';
import { WharehouseExit2Component } from './system/wharehouse/wharehouse-exit2/wharehouse-exit2.component';
import { ExitDetaile2Component } from './system/wharehouse/wharehouse-exit/exit-detaile2/exit-detaile2.component';
import { WharehouseSelectComponent } from './system/wharehouse/wharehouse-select/wharehouse-select.component';
import { CardexListComponent } from './system/wharehouse/wharehouse-cardex/cardex-list/cardex-list.component';
import { CardexDetaileComponent } from './system/wharehouse/wharehouse-cardex/cardex-detaile/cardex-detaile.component';
import { WharehousePlaceComponent } from './system/wharehouse/wharehouse-place/wharehouse-place.component';
import { WharehouseMaterialCate2Component } from './system/wharehouse/wharehouse-material-cate2/wharehouse-material-cate2.component';
import { WharehouseMaterialCate2DetaileComponent } from './system/wharehouse/wharehouse-material-cate2-detaile/wharehouse-material-cate2-detaile.component';
import { WharehouseMaterialCate3Component } from './system/wharehouse/wharehouse-material-cate3/wharehouse-material-cate3.component';
import { WharehouseMaterialCate3DetaileComponent } from './system/wharehouse/wharehouse-material-cate3-detaile/wharehouse-material-cate3-detaile.component';
import { WharehouseWeightComponent } from './system/wharehouse/wharehouse-weight/wharehouse-weight.component';
import { CkdListComponent } from './sale/ckd-list/ckd-list.component';
import { CkdDetaileComponent } from './sale/ckd-detaile/ckd-detaile.component';
import { CkdMaterialComponent } from './sale/ckd-material/ckd-material.component';
import { CdkMaterialDetaileComponent } from './sale/cdk-material-detaile/cdk-material-detaile.component';
import { CkdMaterialListComponent } from './sale/ckd-material-list/ckd-material-list.component';
import { CdkStatusComponent } from './sale/cdk-status/cdk-status.component';
import { CkdInvoiceComponent } from './sale/ckd-invoice/ckd-invoice.component';
import { SiteMaterialListPrintComponent } from './sale/site-material-list-print/site-material-list-print.component';
import { CkdLetterComponent } from './sale/ckd-letter/ckd-letter.component';
import { CkdMaterialList2Component } from './sale/ckd-material-list2/ckd-material-list2.component';
import { CkdMaterialDetaile2Component } from './sale/ckd-material-detaile2/ckd-material-detaile2.component';
import { SaleInvoiceComponent } from './sale/sale-factor/sale-invoice/sale-invoice.component';
import { TipCateComponent } from './sale/tip-cate/tip-cate.component';
import { TipListComponent } from './sale/tip-list/tip-list.component';
import { TipDetaileComponent } from './sale/tip-detaile/tip-detaile.component';
import { TipMeterComponent } from './sale/tip-meter/tip-meter.component';
import { TipMeterDetaileComponent } from './sale/tip-meter-detaile/tip-meter-detaile.component';
import { WeightDetaileComponent } from './sale/weight-detaile/weight-detaile.component';
import { TipAttachmentComponent } from './sale/tip-attachment/tip-attachment.component';
import { CkdInvoice2Component } from './sale/ckd-invoice2/ckd-invoice2.component';
import { CkdDefaultContractComponent } from './sale/ckd-default-contract/ckd-default-contract.component';
import { CkdMaterial2Component } from './sale/ckd-material2/ckd-material2.component';
import { CkdMaterial2DetaileComponent } from './sale/ckd-material2-detaile/ckd-material2-detaile.component';

export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ".",
  precision: 0,
  prefix: "",
  suffix: "",
  thousands: ",",
  nullable: false
};




@NgModule({
  declarations: [
    AppComponent,
    HomeComponent, ModulesComponent,
    LoginComponent
    , SaleHomeComponent, SaleLsfPagesComponent
    , ServerBackendListComponent, ServerBackendCodesComponent, SiteCrmProjectComponent
    , SiteHomeComponent, UserListComponent, SaleAttachmentComponent, SaleProcessComponent, SaleShopComponent
    , SaleShopProcessComponent, SaleDocumentDeclarationComponent, SaleDocumentDesign1Component
    , SaleDocumentDesign2Component, SaleDocumentFoundComponent, SaleDocumentProductComponent
    , SaleDocumentSendComponent, WeightComponent, TickComponent
    , AreaComponent, FloorWeightComponent, InstallPlaceComponent, CraterComponent, DesignComponent
    , TipComponent, InstallCeilComponent, InstallStructureComponent, InstallRunPositionComponent
    , InstallSiteComponent, InstallOpenCraterComponent, InstallHeightComponent, ShopFloorComponent
    , SaleProcessDetaileComponent, UserDetaileComponent
    , UserCateComponent, UserJobComponent
    , ShopServiceComponent
    , SaleFactorDetaileComponent, CrmTaskComponent, CrmTaskDetaileComponent
    , SiteCrmCoopComponent, SiteCrmVisitComponent, UserUvalueComponent
    , UserDetaile2Component, DashboardComponent, SalePrintComponent, SaleSearchComponent
    , UserInsertComponent, SaleCommentComponent, SalePaymentListComponent, SalePaymentDetaileComponent
    , SalePaymentsList2Component, SubstrPipe, PaccessComponent, GaccessComponent, MenuItemsComponent
    , UserGroupsComponent, MaterialListComponent, MaterialDetaileComponent, WharehouseOrderStatusComponent
    , OrderListComponent, OrderDetaileComponent, WharehouseMaterialCateComponent, WharehouseMaterialCateDetaileComponent
    , WharehouseMaterial2Component, WharehouseCostCenterComponent, ExitListComponent, ExitDetaileComponent
    , InvoiceListComponent, InvoiceDetaileComponent, WharehouseInvoiceTypeComponent, SearchMaterialComponent
    , NewFastMaterialComponent, Wreport1Component, ChequeDetaileComponent, Financial2DetaileComponent
    , BankAccountsComponent, AccountsDetaileComponent, BankChequeNumbersComponent, ChequeSelectComponent, NewFastMaterial2Component,
    TabComponent, WharehouseExit2Component, ExitDetaile2Component, WharehouseSelectComponent, CardexDetaileComponent
    , CardexDetaileComponent, CardexListComponent, WharehousePlaceComponent, WharehouseMaterialCate2Component, WharehouseMaterialCate2DetaileComponent, WharehouseMaterialCate3Component, WharehouseMaterialCate3DetaileComponent, WharehouseWeightComponent, CkdListComponent, CkdDetaileComponent, CkdMaterialComponent, CdkMaterialDetaileComponent, CkdMaterialListComponent, CdkStatusComponent, CkdInvoiceComponent, SiteMaterialListPrintComponent, CkdLetterComponent, CkdMaterialList2Component, CkdMaterialDetaile2Component, SaleInvoiceComponent, TipCateComponent, TipListComponent, TipDetaileComponent, TipMeterComponent, TipMeterDetaileComponent, WeightDetaileComponent, TipAttachmentComponent, CkdInvoice2Component, CkdDefaultContractComponent, CkdMaterial2Component, CkdMaterial2DetaileComponent
  ],
  imports: [
    appRoutingModule,
    BrowserAnimationsModule, MatInputModule, MatProgressSpinnerModule, BrowserModule, DropzoneModule, MatTabsModule, MatProgressBarModule,
    BrowserModule, FormsModule, NgxSmartModalModule.forRoot(),
    HttpClientModule, MatDialogModule, MatIconModule, MatSnackBarModule
    , NgxCurrencyModule.forRoot(customCurrencyMaskConfig), MatTableModule, MatCheckboxModule
    , MatSidenavModule, MatMenuModule, ReactiveFormsModule
    , ScrollToModule.forRoot(), MatNativeDateModule, FlexLayoutModule, MatCoreModule, HighchartsChartModule, RichTextEditorModule
  ],
  providers: [CrmTaskComponent, SearchSupplierService, ProfileService, ShopServiceComponent,
    { provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG }, ServerService,
    { provide: MatDialogRef, useValue: {} }
  ],
  entryComponents: [UserDetaile2Component, MessageService, CrmTaskDetaileComponent, SaleFactorDetaileComponent, UserDetaileComponent, SaleProcessDetaileComponent, ServerBackendCodesComponent, SaleAttachmentComponent, SaleShopProcessComponent, SaleDocumentDeclarationComponent, SaleDocumentDesign1Component, SaleDocumentDesign2Component, SaleDocumentSendComponent, SaleDocumentFoundComponent, SaleDocumentProductComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
